import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone: false,
  selector: 'app-confirm-delete-new',
  template: `
      <div class="modal-header py-2 bg-light" *transloco="let t">
        <h5 class="modal-title">{{ t(titlePage) }}</h5>
        <button type="button" class="btn-close" aria-label="Close"
        (click)="onClose()"></button>
      </div>
      <div class="modal-body">
        @if (totalPages && isCheck) {
          <div class="mt-2">
            <app-progress-bar [totalPages]="totalPages" [currentPage]="currentPage"></app-progress-bar>
          </div>
        }
        @if (isCompleteError.length) {
          <div class="alert alert-info col-12 mt-2">
            <div class="customScroll">
              @for (ms of isCompleteError; track ms) {
                <div>
                  <p class="m-0" [innerHTML]="ms"></p>
                </div>
              }
            </div>
          </div>
        }
      </div>
      `,
  styles: [`
      .customScroll {
         height: 100px;
         overflow-y: auto;
         -ms-overflow-style: -ms-autohiding-scrollbar;
         scrollbar-width: thin;
         scrollbar-color: var(--gray-600) transparent;
      }
   `],
  encapsulation: ViewEncapsulation.None
})
export class ConfirmDeleteNewComponent {
  @Input() titlePage = 'common.deleteSelectedLines';
  @Input() totalPages: number = 0;
  @Input() isCheck: boolean = false;
  @Input() currentPage: number = 0;
  @Input() isCompleteError: string[] = [];
  @Output() progressUpdate = new EventEmitter<number>();

  constructor(
    public _modalService: NgbActiveModal
  ) {
  }

  onClose() {
    this._modalService.close(true);
  }

  updateProgress(progress: number) {
    this.currentPage = progress;
    this.progressUpdate.emit(this.currentPage);
  }
}
